export default __webpack_public_path__ + "static/media/apache.7037bb8d.svg";